class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // Safari-specific fix: Handle link clicks inside dropdown
    this.content.addEventListener('click', this.onContentClick.bind(this));
  }

  onFocusOut(event) {
    // Safari-specific fix: Don't close dropdown if user is clicking a link inside it
    if (event.relatedTarget && this.contains(event.relatedTarget)) {
      return;
    }

    // Add longer timeout for Safari to prevent premature closing when clicking links
    const timeout = navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome') ? 100 : 0;

    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    }, timeout);
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  onContentClick(event) {
    // Safari-specific fix: Allow navigation when clicking links
    if (event.target.tagName === 'A' || event.target.closest('a')) {
      // Allow the link to navigate, don't prevent default or close dropdown
      return;
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
